import { render } from "./PublicationDomainConfiguration.vue.js?vue&type=template&id=3cf91b52!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDomainConfiguration.vue?vue&type=template&id=3cf91b52"
import script from "./PublicationDomainConfiguration.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDomainConfiguration.vue?vue&type=script&lang=js"
export * from "./PublicationDomainConfiguration.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDomainConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/features/PublicationDomainConfiguration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cf91b52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cf91b52', __exports__)) {
    api.reload('3cf91b52', __exports__)
  }
  
  module.hot.accept("./PublicationDomainConfiguration.vue.js?vue&type=template&id=3cf91b52!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDomainConfiguration.vue?vue&type=template&id=3cf91b52", () => {
    api.rerender('3cf91b52', render)
  })

}


export default __exports__